import * as actions from "./AdminAbstractTypeActions";
import { AdminAbstractTypeState, initialAdminAbstractTypeState } from "./AdminAbstractTypeState";
import buildReducer from "../../utils/ReducerBuilder";

export const AdminAbstractTypeReducer = buildReducer<AdminAbstractTypeState>(initialAdminAbstractTypeState)
    .handle(actions.onInvitationStatusSubscribed, (state, action) => {
        if (action.payload === undefined)
            return state;

        let subscribedInvitationUpdates = state.subscribedInvitationUpdates.toList();
        const subIdx = subscribedInvitationUpdates.findIndex((x) => x !== undefined
            && action.payload !== undefined
            && x.abstractTypeId === action.payload.abstractTypeId);

        if (subIdx > -1 && !action.payload.subscribed)
            subscribedInvitationUpdates = subscribedInvitationUpdates.remove(subIdx);
        else if (subIdx === -1)
            subscribedInvitationUpdates = subscribedInvitationUpdates.push({ abstractTypeId: action.payload.abstractTypeId });

        return {
            ...state,
            subscribedInvitationUpdates,
        };
    })
    .handle(actions.onInvitationStatusUpdated, (state, action) => ({
        ...state,
        subscribedInvitationUpdates: action.payload || state.subscribedInvitationUpdates,
    }))
    .handle(actions.onTypesUpdated, (state, action) => ({
        ...state,
        types: action.payload || state.types,
    }))
    .handle(actions.toggleLoadingType, (state, action) => {
        if (action.payload === undefined)
            return state;

        const loadingType = { ...state.loadingType };
        loadingType[action.payload.id] = action.payload.loading;

        return {
            ...state,
            loadingType,
        };
    })
    .handle(actions.toggleLoadingTypes, (state, action) => ({
            ...state,
            loadingTypes: action.payload || false,
    }))
    .done();



// WEBPACK FOOTER //
// ./src/store/adminAbstractType/AdminAbstractTypeReducer.ts